import {useGlobalStateVariable} from '../providers/global-state';

import {useUserEditingPermissions} from './user/use-has-permission';
import {useRoute} from 'wouter';

export function useNavigationInfo() {
    const {editingPermitted} = useUserEditingPermissions();

    const [viewModeLastLocation] = useGlobalStateVariable('documents.explore.lastLocation', '');
    const [editModeLastLocation] = useGlobalStateVariable('documents.edit.lastLocation', '');
    const [queriesLastLocation] = useGlobalStateVariable('queries.lastLocation', '');

    const [isExploreModeActive] = useRoute('/documents/explore/*?');
    const [isEditModeActive] = useRoute('/documents/edit/*?');
    const [isQueriesActive] = useRoute('/queries/*?');

    const activeRoute = (function () {
        if (isExploreModeActive) return 'explore';
        if (isEditModeActive) return 'edit';
        if (isQueriesActive) return 'queries';
        return undefined;
    })();

    return {
        activeRoute,
        list: [
            {
                title: 'Explore mode',
                label: 'Explore',
                value: 'explore',
                path: viewModeLastLocation
                    ? `/documents/explore/${viewModeLastLocation}`
                    : '/documents/explore',
                isActive: isExploreModeActive
            },
            ...(editingPermitted
                ? [
                      {
                          title: 'Edit mode',
                          label: 'Edit',
                          value: 'edit',
                          path: editModeLastLocation
                              ? `/documents/edit/${editModeLastLocation}`
                              : '/documents/edit',
                          isActive: isEditModeActive
                      }
                  ]
                : []),
            {
                title: 'Queries',
                label: 'Queries',
                value: 'queries',
                path: queriesLastLocation ? `/queries/${queriesLastLocation}` : '/queries',
                isActive: isQueriesActive
            }
        ]
    };
}
